/*# sourceMappingURL=customer-details.component-PPX7TETA.css.map */
